// extracted by mini-css-extract-plugin
module.exports = {"contactInfoHeader":"Contact_contactInfoHeader__3XVqO","socialLogo":"Contact_socialLogo__2Anxh"};